import React, { useEffect, useState, useCallback, memo } from 'react';
import { Box, Button, Flex, Popover, Image, PopoverTrigger } from '@chakra-ui/react';

import { Toolbar, Table } from './components';
import { RouteComponentProps } from 'react-router';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import useEventBus from 'hooks/useEventBus';
import { getLoggedUser } from 'utils/storage';
import IAarchive from 'assets/icons/archived.svg';
import { getListSumulations, donwloadSimulationFile } from 'services/Simulator';
import { ISimulationFine } from 'models/Forms/Simultation';

interface IProps extends RouteComponentProps {}

const DemandsComp: React.FC<IProps> = ({ history }) => {
  const [data, setData] = useState<ISimulationFine>({ content: [], totalPages: 1 });
  const [isLoading, setIsLoading] = useState(false);
  const eventBus = useEventBus();
  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', 'Multas Simuladas');
  }, []);

  const handleGetData = useCallback(async (query?: string) => {
    setIsLoading(true);

    try {
      const clientId = getLoggedUser().client;

      const defaultQuery = `size=10&sort=prazo,asc${clientId ? `&clientId=${clientId}` : ''}`;
      let newQuery = `?${defaultQuery}`;

      if (query) {
        if (query[0] === '?') {
          newQuery = `${query}&${defaultQuery}1`;
        } else {
          newQuery = `?${query}&${defaultQuery}`;
        }
      }

      if (newQuery.includes('?')) {
        newQuery = newQuery.slice(1);
      }

      const response = await getListSumulations(query);
      setData(response.data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, []);
  const handlePaginate = (newPage: number) => {
    const newFilterData = queryToObj(history.location.search);

    function valuePositive(value: number) {
      const query = localStorage.getItem('queryPageDemands') || '';
      if (value === -1) {
        return 0;
      } else if (value === Number(query)) {
        return Math.abs(Number(query));
      } else {
        return Math.abs(value - 1);
      }
    }

    const query = objToQuery({ ...newFilterData, page: valuePositive(newPage) });
    if (
      newFilterData.page &&
      typeof newFilterData.page === 'string' &&
      newPage - 1 === parseInt(newFilterData.page)
    )
      return;

    history.replace({
      pathname: routePaths.simulatedFines,
      search: `?${query}`,
    });
  };

  const formatExpirationDate = (data: string) => {
    return data !== null
      ? new Date(data).toLocaleDateString('pt-Br', {
          timeZone: 'UTC',
        })
      : '-';
  };

  useEffect(() => {
    handleGetData(history.location.search);
    const removeListen = history.listen(listener => handleGetData('?' + listener.search.slice(1)));
    return () => {
      removeListen();
    };
  }, []);

  const download = async (id: string) => {
    try {
      const res = await donwloadSimulationFile(id);
      const blob = new Blob([res.data], { type: res.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'arquivo');
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Box w="100%">
      <Toolbar history={history} />
      <Box padding="0.1rem 0rem 1rem" background="#fff" borderRadius="10px">
        <Table
          loading={isLoading}
          row={[0]}
          headers={[
            'Criado por',
            'E-mail',
            'Empresa',
            'Origem',
            'Data',
            'Grau de infração',
            'Valor',
            'Anexo',
          ]}
          sizes={[2, 2, 1.3, 1, 1, 1, 1.3, 1]}
          fullLoading={false}
          handles={[]}
          buttons={data?.content.map(simulation => (
            <Flex
              key={simulation.id}
              alignItems={'center'}
              marginLeft={'-2rem'}
              className="containerFlex"
              width="100%"
              justify="flex-start"
              pl="1rem"
            >
              {simulation.temDocumento && (
                <Popover>
                  <PopoverTrigger>
                    <Button className="boxPopover" onClick={() => download(String(simulation.id))}>
                      <Image src={IAarchive} alt="Ícone de desarquivar" />
                    </Button>
                  </PopoverTrigger>
                </Popover>
              )}
            </Flex>
          ))}
          rows={data?.content.map(simulation => [
            simulation.createdBy,
            simulation.email,
            simulation.empresa,
            simulation.origem,
            formatExpirationDate(simulation.createdAt),

            simulation.grauInfracao,
            new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
              simulation.valorSimulado,
            ),
          ])}
          pagination={{
            initialPage: Number(localStorage.getItem('queryPageDemands')) + 1 ?? 1,
            onChange: handlePaginate,
            pagesCount: data?.totalPages || 1,
          }}
        />
      </Box>
    </Box>
  );
};

export const SimulatedFines = memo(DemandsComp);
